<template>
  <path 
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M2.35529 29.7614C4.72333 31.0713 6.92395 32.725 9.04472 34.3434C9.50013 34.6933 9.59907 35.3464 
    9.23683 35.7714C8.90327 36.2252 8.2553 36.3019 7.82886 35.9805C5.77491 34.4103 3.64717 32.7994 1.38521 
    31.5559C0.90129 31.2928 0.716238 30.6685 0.980117 30.1694C1.24371 29.6705 1.87108 29.4986 2.35529 29.7614Z"
  />
  <path 
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M4.4652 16.7232C10.4556 16.6232 16.4358 17.287 22.4489 17.0481C22.9979 17.0134 23.7082 17.7136 
    23.7476 18.7809C23.787 19.8482 23.2681 20.4634 22.6901 20.4695C16.6682 20.7174 10.6794 20.0623 4.68017 
    20.1713C4.10901 20.1704 3.12489 18.6363 3.12489 18.6363C2.84447 17.813 3.89404 16.7223 4.4652 16.7232Z"
  />
  <path 
    fill-rule="evenodd" 
    clip-rule="evenodd" 
    d="M9.46705 2.45088C7.65967 4.10824 5.85246 5.76578 4.04479 7.42343C3.65071 7.82271 2.99856 7.78767 
    2.61206 7.36789C2.22585 6.94781 2.27172 6.32212 2.66609 5.92255C4.47633 4.26228 6.28611 2.60214 8.09607
     0.942165C8.51912 0.571482 9.16916 0.608444 9.55337 1.03055C9.9086 1.42405 9.88982 2.08048 9.46705 2.45088Z"
  />
</template>

<script>
export default {

}
</script>

<style scoped>

    path {
        font-family: var(--iconFontFamily);
        font-size: var(--iconFontSize);
        fill: var(--iconTextColor);
    }
</style>